export const USER_LIST = 'USER_LIST';
export const TOKEN = 'TOKEN';
export const ROLE = 'ROLE';
export const USER_DELETE = 'USER_DELETE';
export const USER_CREATE = 'USER_CREATE';
export const USER_INVITATION = 'USER_INVITATION';
export const USER_DETAIL = 'USER_DETAIL';
export const USER_ALL = 'USER_ALL';
export const USER_UPDATE = 'USER_UPDATE';
export const GET_ALL_USER_LIST='GET_ALL_USER_LIST';
export const INPERSONATE_USER_LIST = 'INPERSONATE_USER_LIST';
//Customer action types
export const CUSTOMER_LIST = 'CUSTOMER_LIST';
export const CUSTOMER_DELETE = 'CUSTOMER_DELETE';
export const CUSTOMER_CREATE = 'CUSTOMER_CREATE';
export const CUSTOMER_INVITATION = 'CUSTOMER_INVITATION';
export const CUSTOMER_DETAIL = 'CUSTOMER_DETAIL';
export const CUSTOMER_ALL = 'CUSTOMER_ALL';
export const CUSTOMER_UPDATE = 'CUSTOMER_UPDATE';
export const CUSTOMER_GET = 'CUSTOMER_GET';
export const CUSTOMER_INFO_UPDATE = 'CUSTOMER_INFO_UPDATE';
export const CUSTOMER = 'CUSTOMER';
export const CLIENT_ADMIN_CUSTOMER='CLIENT_ADMIN_CUSTOMER';
//Document action types
export const DOCUMENT_UPLOAD = 'DOCUMENT_UPLOADT';
export const ALL_DOCUMENT = 'ALL_DOCUMENT';
export const DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT'
export const PERMISSION_USER = 'PERMISSION_USER';
export const GROUP_USER_PERMISSION = 'GROUP_USER_PERMISSION';
export const USER_DELETE_PERMISSION = 'USER_DELETE_PERMISSION';
export const USER_GROUP_DELETE_PERMISSION = 'USER_GROUP_DELETE_PERMISSION';
export const DOCUMENT_FILE_UPDATE="DOCUMENT_FILE_UPDATE";
export const DOCUMENT_DELETE = "DOCUMENT_DELETE";
//UserGroup action types
export const GET_USER_GROUP_BYID ="GET_USER_GROUP_BYID";
export const CREATE_USER_GROUP ="CREATE_USER_GROUP";
export const UPDATE_USER_GROUP ="UPDATE_USER_GROUP";
export const ALL_USER_GROUP="ALL_USER_GROUP";
export const DELETE_USER_GROUP="DELETE_USER_GROUP";
export const ADD_USER_FORM_GROUP="ADD_USER_FORM_GROUP";
//DocumentGroup action types
export const GET_DOCUMENT_GROUP_BYID ="GET_DOCUMENT_GROUP_BYID";
export const CREATE_DOCUMENT_GROUP ="CREATE_DOCUMENT_GROUP";
export const UPDATE_DOCUMENT_GROUP ="UPDATE_DOCUMENT_GROUP";
export const ALL_DOCUMENTS_GROUP ="ALL_DOCUMENT_GROUP";
export const DELETE_DOCUMENT_GROUP ="DELETE_DOCUMENT_GROUP";
export const ADD_DOCUMENT_FORM_GROUP ="ADD_DOCUMENT_FORM_GROUP";
export const TREE_STRUCTURE_LIST_DOCUMENT_GROUP ="TREE_STRUCTURE_LIST_DOCUMENT_GROUP";
//Ftp process 
export const FTP_PROCESS="FTP_PROCESS";
//Permission 
export const ADD_PERMISSION="ADD_PERMISSION";
export const DOCUMENT_GROUP_PERMISSION="DOCUMENT_GROUP_PERMISSION";
export const DELETE_HARD="DELETE_HARD";